export const citiesAdapter = (data) => [{ id: 0, name: 'همه شهرها' }, ...data];
